export default __webpack_public_path__ + "static/math-wizard-d2b17c77471a470de73c28fb35d7336d.svg";